// extracted by mini-css-extract-plugin
module.exports = {"overviewsContainer":"CapabilitiesOverview_overviewsContainer__V1JH_"};